// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__EAlSR","row":"List_row__mQC5n","columnHeaders":"List_columnHeaders__4Hmj7","fallback":"List_fallback__O8Q9k"};